'use client';

export { default } from './TableContainer';
export { default as tableContainerClasses } from './tableContainerClasses';
export * from './tableContainerClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableContainer/index.js
// module id = 893
// module chunks = 22